import './layer.scss';

const layer = {
	showLoading: () => {
		const box = document.createElement('div');
		box.innerHTML = `<div class="layer-loading"><svg viewBox="0 0 400 400"><path d="M169.06,365.944c0-17.254,13.987-31.242,31.242-31.242s31.242,13.987,31.242,31.242-13.987,31.242-31.242,31.242-31.242-13.987-31.242-31.242ZM47.866,314.327c0-16.754,13.582-30.336,30.336-30.336s30.336,13.582,30.336,30.336-13.582,30.336-30.336,30.336-30.336-13.582-30.336-30.336h0ZM1.683,200.226c0-15.254,12.366-27.62,27.62-27.62s27.62,12.366,27.62,27.62-12.366,27.62-27.62,27.62S1.683,215.48,1.683,200.226ZM50.583,75.712c0-13.253,10.744-23.997,23.997-23.997s23.997,10.744,23.997,23.997-10.744,23.997-23.997,23.997-23.997-10.744-23.997-23.997h0ZM180.38,23.696c0-11.532,9.349-20.881,20.881-20.881s20.881,9.349,20.881,20.881-9.349,20.881-20.881,20.881-20.881-9.349-20.881-20.881h0ZM314.855,71.613c0-8.268,6.703-14.971,14.971-14.971s14.971,6.703,14.971,14.971-6.703,14.971-14.971,14.971-14.971-6.703-14.971-14.971ZM377.105,200.789c0-5.857,4.748-10.606,10.606-10.606s10.606,4.748,10.606,10.606-4.748,10.606-10.606,10.606-10.606-4.748-10.606-10.606h0ZM345.25,312.027c0-4.187,3.394-7.582,7.582-7.582s7.582,3.394,7.582,7.582-3.394,7.582-7.582,7.582-7.582-3.394-7.582-7.582Z" /></svg></div>`;
		document.body.append(box);
	},
	hideLoading: () => {
		const box = document.querySelector('.layer-loading').parentNode;
		if (box) {
			box.remove();
		}
	},
	msg: (title, options) => {
		const box = document.createElement('div');
		box.innerHTML = `<div class="layer-msg"><p>${title}</p></div>`;
		document.body.append(box);
		setTimeout(() => {
			box.remove();
		}, 2000);
	}
}

export { layer }